import { Box } from "@chakra-ui/react";
import { Typewriter } from "react-simple-typewriter";

const Animation = ({ msg }) => {
  return (
    <Box ml={1}>
      <Typewriter
        words={[msg]}
        typeSpeed={5}
        deleteSpeed={50}
        delaySpeed={1000}
      />
    </Box>
  );
};

export default Animation;
